var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C114.6,0,0,114.6,0,256c0,141.4,114.6,256,256,256c141.4,0,256-114.6,256-256C512,114.6,397.4,0,256,0 z M373.4,369.2c-4.6,7.6-14.4,9.9-21.9,5.3c-60.1-36.7-135.8-45-224.9-24.7c-8.6,2-17.2-3.4-19.1-12c-2-8.6,3.4-17.2,12-19.1 c97.5-22.3,181.2-12.7,248.6,28.5C375.6,351.9,378,361.7,373.4,369.2z M404.7,299.5c-5.8,9.4-18.1,12.3-27.5,6.6 c-68.8-42.3-173.7-54.5-255.1-29.8c-10.5,3.2-21.7-2.8-24.9-13.3c-3.2-10.6,2.8-21.7,13.3-24.9c93-28.2,208.6-14.5,287.6,34 C407.6,277.9,410.5,290.2,404.7,299.5z M407.4,226.9c-82.5-49-218.6-53.5-297.4-29.6c-12.7,3.8-26-3.3-29.9-16 c-3.8-12.7,3.3-26,16-29.9c90.4-27.5,240.7-22.1,335.7,34.2c11.4,6.8,15.1,21.4,8.4,32.8C433.5,230,418.8,233.7,407.4,226.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.46ebfef0009c81170dfc8cb93e1c9bb3.svg";
export { ForwardRef as ReactComponent };